import { render, staticRenderFns } from "./FormResponseType4.vue?vue&type=template&id=1adbcf5a&scoped=true"
import script from "./FormResponseType4.vue?vue&type=script&lang=js"
export * from "./FormResponseType4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1adbcf5a",
  null
  
)

export default component.exports